import React from 'react';
import PropTypes from 'prop-types';
import * as currency from '@shopify/theme-currency';
import axios from 'axios';
import CartItem from './CartItem';

function FreeShippingBar({total, treshold}) {
  let barPercentege = (total / treshold) * 100;
  const leftAmount = treshold - total;
  let message = `You are ${currency.formatMoney(
    leftAmount,
    window.theme.moneyFormat,
  )} away from Free Shipping`;
  if (leftAmount <= 0) {
    message = 'Free Shipping';
  }

  if (barPercentege > 100) {
    barPercentege = 100;
  }

  const barWidth = {
    width: `${barPercentege}%`,
  };

  return (
    <div className="sidecart__free-shipping">
      <div className="sidecart__progress">
        <div className="bar" style={barWidth} />
      </div>
      <p>{message}</p>
    </div>
  );
}

function handleCartUpsellClickEvent(evt, id, addToCart) {
  const target = evt.target.parentElement;
  target.style.display = 'none';

  addToCart(evt, id);
}

function CartUpsell({variantId, addToCart, enabled}) {
  const upsellProductImage = window.theme.cartUpsell
    ? window.theme.cartUpsell.productImage
    : null;
  const upsellImage = window.theme.cartUpsell
    ? window.theme.cartUpsell.image
    : null;
  const upsellPrice = window.theme.cartUpsell
    ? window.theme.cartUpsell.price
    : null;
  const upsellTitle = window.theme.cartUpsell
    ? window.theme.cartUpsell.productTitle
    : '';

  let image = upsellImage;
  if (!upsellImage || upsellImage === '') {
    image = upsellProductImage;
  }

  return (
    <div className="cart-upsell">
      <div className="cart-upsell__image">
        <img src={image} />
      </div>
      <div className="cart-upsell__content">
        <p>{upsellTitle}</p>
        <p>{currency.formatMoney(upsellPrice, window.theme.moneyFormat)}</p>
      </div>
      <div className="cart-upsell__add">
        <span
          onClick={(evt) =>
            handleCartUpsellClickEvent(evt, variantId, addToCart)
          }
        >
          Add
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
          >
            <path
              d="M5 10.5h10m-5-5v10"
              fill="none"
              fillRule="evenodd"
              stroke="#ffffff"
              strokeLinecap="square"
            />
          </svg>
        </span>
      </div>
    </div>
  );
}

function PaymentIcon({icon}) {
  return (
    <React.Fragment>
      {icon.enabled && <span dangerouslySetInnerHTML={{__html: icon.icon}} />}
    </React.Fragment>
  );
}

class SideCart extends React.Component {
  constructor(props) {
    super(props);
    window.sideCart = this;
    this.updateCart = this.updateCart.bind(this);
    this.handleAddToCartEvent = this.handleAddToCartEvent.bind(this);
    this.checkForUpsellProduct = this.checkForUpsellProduct.bind(this);
    this.removeUpsell = this.removeUpsell.bind(this);

    this.state = {
      itemsCount: window.theme.cart ? window.theme.cart.item_count : 0,
      total: window.theme.cart ? Number(window.theme.cart.total_price) : 0,
      freeShippingBar: window.theme.freeShipping
        ? window.theme.freeShipping.enabled
        : false,
      treshold: window.theme.freeShipping
        ? Number(window.theme.freeShipping.treshold)
        : 0,
      cartItems: window.theme.cart ? window.theme.cart.items : [],
      hasUpsell: window.theme.cartUpsell
        ? window.theme.cartUpsell.enabled
        : false,
      upsellVariantId: window.theme.cartUpsell
        ? window.theme.cartUpsell.variantId
        : null,
    };
  }

  updateCart(cart) {
    this.setState({
      itemsCount: cart.item_count,
      total: cart.total_price,
      cartItems: cart.items,
    });
    const headerCounter = document.querySelector('[data-items-count]');
    if (headerCounter) {
      headerCounter.innerHTML = cart.item_count;
    }
  }

  handleAddToCartEvent(evt, id, qty = 1, openCart = false) {
    axios({
      method: 'POST',
      url: '/cart/add.js',
      data: {
        id,
        quantity: qty,
      },
      responseType: 'JSON',
    })
      .then(() => {
        axios({
          method: 'GET',
          url: '/cart.js',
          responseType: 'JSON',
        })
          .then((response) => {
            this.updateCart(response.data);
            this.checkForUpsellProduct(id, response.data.items);
            setTimeout(() => {
              if (!document.body.classList.contains('upsell__variant-modal--is-visible')) {
                document.body.classList.add('cart-is-visible');
              }
            }, 10);
          })
          .catch((err) => window.console.log(err));
      })
      .catch((err) => window.console.log(err));
  }

  handleCartToggle(event, remainingUpsell) {
    if (event) {
      event.preventDefault();
    }
    if (remainingUpsell) {
      document.body.classList.add('upsell__variant-modal--is-visible');
    } else {
      document.body.classList.remove('upsell__variant-modal--is-visible');
      document.body.classList.toggle('cart-is-visible');
    }
  }

  checkForUpsellProduct(id, cartItems) {
    if (!cartItems) {
      cartItems = this.state.cartItems;
    }
    const {cartUpsells} = window;
    const {productID} = window;

    /**
     * If no upsells setup abort.
     */
    if (!cartUpsells.length) {
      return;
    }

    /**
     * If is main product return early
     */
    const isMainProduct = cartUpsells.some((upsell) => upsell.product.id === productID || upsell.collectionProducts.some(product => product.id === productID));
    if (!isMainProduct) {
      return;
    }

    /**
     * An array of all main product ids.
     */
    const mainUpsellProducts = cartUpsells.reduce((acc, curr) => {
      const collectionProductIds = curr.collectionProducts.map(({id}) => id);
      return [...acc, curr.product.id, ...collectionProductIds];
    }, []);
    const cartHasMainUpsellProduct = cartItems.some((item) =>
      mainUpsellProducts.includes(item.product_id));

    /**
     * If cart doesn't have a main upsell product abort.
     */
    if (!cartHasMainUpsellProduct) {
      return;
    }

    const addedItemUpsell = cartUpsells.find(
      ({product, collectionProducts}) =>
        product.variants.includes(id) ||
        collectionProducts.some(({variants}) => variants.includes(id)),
    );

    /**
     * Get current products upsell products
     */
    const currentUpsellProducts = cartUpsells.find(currentUpsell => {
      return currentUpsell.product.id === productID || currentUpsell.collectionProducts.some(product => product.id === productID);
    });

    /**
     * Get upsell product data that contains variants
     */
    let upsellProducts = [];
    upsellProducts = currentUpsellProducts.upsellProducts.filter((upsellProduct) => upsellProduct.variants.length > 1);

    /**
     * If the current upsell product to be added to cart has variants, trigger variant selection modal
     */
    if (upsellProducts.length > 0) {
      if (document.body.classList.contains('delay-upsell-modal')) {
        document.body.classList.remove('delay-upsell-modal');
      } else {
        document.body.classList.add('upsell__variant-modal--is-visible');
      }
    }

    /**
     * If the current added product is not part of an upsell abort.
     */
    if (!addedItemUpsell) {
      return;
    }

    /**
     * If the variant ID passed to this function is not in the cart abort.
     */
    const addedItem = cartItems.filter((item) => item.variant_id === id);

    if (!addedItem) {
      return;
    }

    /**
     * Get upsell product data that does not contain variants
     */
    let singleVariantUpsellProducts = currentUpsellProducts.upsellProducts.filter((upsellProduct) => upsellProduct.variants.length === 1 || upsellProduct.variants.length < 1);

    /**
     * If no items are left without variants then return early.
     */
    if (singleVariantUpsellProducts.length < 1) {
      return;
    }

    /**
     * Check if the upsell products are already in the cart.
     */
    const addedFreeProds = cartItems.filter((item) =>
    singleVariantUpsellProducts.includes(item.variant_id.toString()));

    if (addedFreeProds.length >= singleVariantUpsellProducts.length) {
      return;
    }

  /**
   * Filter out any products that aren't available
   */
    singleVariantUpsellProducts = singleVariantUpsellProducts.filter(upsell => upsell.upsellProductData.selectedVariant.available === true);

  /**
   * Filter out any empty products that might break the cart POST request
   */
    singleVariantUpsellProducts = singleVariantUpsellProducts.filter(upsell => upsell.id !== '');


  /**
   * Construct array of objects for single/default variant products that need to be added to cart
   */
    const addPayload = singleVariantUpsellProducts.map((product) => {
      return {
        id: product.variants[0],
        quantity: 1,
      };
    });

    if (upsellProducts.length < 1) {
      document.body.classList.add('cart-is-visible');
    }

    axios({
      method: 'POST',
      url: '/cart/add.js',
      data: {
        items: addPayload,
      },
      responseType: 'JSON',
    })
      .then(() => {
        axios({
          method: 'GET',
          url: '/cart.js',
          responseType: 'JSON',
        })
          .then((response) => {
            this.updateCart(response.data);
          })
          .catch((err) => window.console.log(err));
      })
      .catch((err) => window.console.log(err));
  }

  removeUpsell(id, cartItems) {
    if (!cartItems) {
      cartItems = this.state.cartItems;
    }

    const {cartUpsells} = window;

    /**
     * If no upsells setup abort.
     */
    if (!cartUpsells.length) {
      return;
    }

    /**
     * If the item removed is not part of an upsell abort.
     */
    const removedItemUpsell = cartUpsells.find(
      ({product, collectionProducts}) =>
        product.variants.includes(id) ||
        collectionProducts.some(({variants}) => variants.includes(id)),
    );

    if (!removedItemUpsell) {
      return;
    }

    const itemsToRemove = removedItemUpsell.productList;

    /**
     * If the cart doesn't have upsell items to remove abort.
     */
    const cartHasItemsToRemove = cartItems.some((item) => {
      return itemsToRemove.includes(item.variant_id.toString());
    });
    if (!cartHasItemsToRemove) {
      return;
    }

    /**
     * If the cart has upsell items that need to be removed build out the payload.
     * We need to find the line item and reduce the quantity by 1 instead of directly removing it.
     *
     * This is due to the possibility that the user might have added the upsell product that needs to be removed
     * as a standalone product to the cart.
     */
    const updatePayload = itemsToRemove.reduce((acc, curr) => {
      const matchingLineItem = cartItems.find(
        (item) => item.variant_id.toString() === curr,
      );

      if (matchingLineItem) {
        return {
          ...acc,
          [curr]: matchingLineItem.quantity - 1,
        };
      }

      return acc;
    }, {});

    axios({
      method: 'POST',
      url: '/cart/update.js',
      data: {updates: updatePayload},
      responseType: 'JSON',
    })
      .then((response) => {
        this.updateCart(response.data);
      })
      .catch((err) => window.console.log(err));
  }

  randomInteger() {
    return Math.floor(Math.random() * 1000000);
  }

  componentDidMount() {
    const cartToggle = document.querySelectorAll('[data-toggle-cart]');
    if (cartToggle.length > 0) {
      cartToggle.forEach((el) =>
        el.addEventListener('click', this.handleCartToggle));
    }
  }

  render() {
    const {
      itemsCount,
      total,
      freeShippingBar,
      treshold,
      cartItems,
      upsellVariantId,
    } = this.state;
    let {hasUpsell} = this.state;

    if (hasUpsell) {
      const isUpsellProductAdded = cartItems.filter(
        (item) => item.variant_id === upsellVariantId,
      );
      if (isUpsellProductAdded.length) {
        hasUpsell = false;
      }
    }

    return (
      <React.Fragment>
        <div className="sidecart__header">
          <div className="sidecart__close" data-toggle-cart>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <g
                fill="none"
                fillRule="evenodd"
                stroke="#084b2a"
                strokeLinecap="square"
              >
                <path d="M4 4l12 12M16 4L4 16" />
              </g>
            </svg>
          </div>
          <h5>{window.theme.strings.cartTitle}</h5>
          <div className="sidecart__items-total">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <g fill="none" fillRule="evenodd">
                <path
                  stroke="#084b2a"
                  d="M16.5 8.5h-13v5.445a3.5 3.5 0 0 0 3.5 3.5h6a3.5 3.5 0 0 0 3.5-3.5V8.5z"
                />
                <path
                  fill="#084b2a"
                  fillRule="nonzero"
                  d="M12 7V6H8v1H7V5a3 3 0 1 1 6 0v2h-1zM8 6h4V5a2 2 0 1 0-4 0v1z"
                />
              </g>
            </svg>
            <span>{itemsCount}</span>
          </div>
        </div>
        {freeShippingBar && (
          <FreeShippingBar total={total} treshold={treshold} />
        )}

        <div className="side-cart__content-container">
          <div className="side-cart__content">
            <div className="cart-items__container">
              {cartItems.length ? (
                cartItems.map((item) => (
                  <CartItem
                    item={item}
                    updateCart={this.updateCart}
                    removeUpsell={this.removeUpsell}
                    key={item.variant_id + this.randomInteger()}
                  />
                ))
              ) : (
                <p className="side-cart__empty">Your Cart is empty</p>
              )}
            </div>

            {hasUpsell && cartItems.length ? (
              <CartUpsell
                variantId={upsellVariantId}
                addToCart={this.handleAddToCartEvent}
                enabled={true}
              />
            ) : null}
          </div>
          <div className="side-cart__totals">
            <div className="side-cart__subtotals">
              <div className="side-cart__subtotal">
                <span>{window.theme.strings.subtotal}</span>
                <span>
                  {currency.formatMoney(total, window.theme.moneyFormat)}
                </span>
              </div>
              <div className="side-cart__subtotal">
                <span>{window.theme.strings.shipping}</span>
                <span>
                  {total === 0 || total >= treshold
                    ? currency.formatMoney(0, window.theme.moneyFormat)
                    : currency.formatMoney(
                        window.theme.shipping_price,
                        window.theme.moneyFormat,
                      )}
                </span>
              </div>
            </div>
            <div>
              <a href="/checkout" className="btn btn--primary-alt">
                {window.theme.strings.checkout}
              </a>
            </div>
            <div className="sidecart__payment-icons">
              {window.paymentIcons && window.paymentIcons.enabled
                ? window.paymentIcons.icons.map((icon, index) => (
                    <PaymentIcon icon={icon} key={index} />
                  ))
                : null}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

FreeShippingBar.propTypes = {
  total: PropTypes.number,
  treshold: PropTypes.number,
};

CartUpsell.propTypes = {
  variantId: PropTypes.number,
  addToCart: PropTypes.func,
  enabled: PropTypes.bool,
};

PaymentIcon.propTypes = {
  icon: PropTypes.object,
};

export default SideCart;
